import React from 'react'
import Section from '@dfb/gatsby-dfb-theme/src/components/blocks/section'
import { concatStrings } from '@dfb/gatsby-dfb-theme/src/components/utilities'

const MSponsoringItem = (props) => {
  const { premium, item, big } = props
  const Link = item.url ? 'a' : 'div'
  const linkProps = item.url
    ? {
        href: item.url,
        target: '_blank',
        rel: 'noopener noreferrer',
      }
    : {}

  const logoSize = big ? 'xl' : premium ? 'm' : 'xs'
  const logoWidth = big ? '128px' : premium ? '82px' : '64px'

  return (
    <li className={concatStrings('m-Sponsoring-item', premium && 'm-Sponsoring-item--premium')}>
      <Link className="m-Sponsoring-link" {...linkProps}>
        <img
          className={`m-Sponsoring-logo m-Sponsoring-logo--${logoSize}`}
          style={{ width: '100%', height: 'auto', maxWidth: logoWidth, maxHeight: logoWidth }}
          alt={item.logo}
          src={`/images/sponsoring/${item.logo}_01.png`}
          loading="lazy"
        />
      </Link>
    </li>
  )
}

const MSponsoring = (props) => {
  const filteredUltraPremiumPartners = props?.data?.premiumPartners.filter((item) => item.logo !== 'none' && item.ultra)

  // The CMS is sending logo:"none" if there is no (premium) partner. We filter them out.
  const filteredPremiumPartner = props?.data?.premiumPartners.filter(
    (item) => item.logo !== 'none' && !filteredUltraPremiumPartners.includes(item)
  )

  const filteredPartner = props?.data?.partners.filter((item) => item.logo !== 'none')

  if (!filteredPartner.length && !filteredPremiumPartner.length) {
    return null
  }

  return (
    <Section testid="sponsoring" baseClass="m-Sponsoring" className="m-Sponsoring--auto-width m-Sponsoring--four-width" data={props.data}>
      <div className="m-Sponsoring-wrapper">
        <div className="m-Sponsoring-container">
          {props.data.headline && <h2 className="m-Sponsoring-headline">{props.data.headline}</h2>}
          {filteredUltraPremiumPartners?.length > 0 && (
            <ul className="m-Sponsoring-list m-Sponsoring-list--premium">
              {filteredUltraPremiumPartners.map((item, index) => (
                <MSponsoringItem item={item} key={index} premium big={true} />
              ))}
            </ul>
          )}
          {filteredPremiumPartner?.length > 0 && (
            <ul className="m-Sponsoring-list m-Sponsoring-list--premium" style={{ marginTop: 0 }}>
              {filteredPremiumPartner.map((item, index) => (
                <MSponsoringItem key={index} item={item} premium big={filteredPremiumPartner.length === 1 && !filteredPartner?.length} />
              ))}
            </ul>
          )}
          {filteredPartner?.length > 0 && (
            <ul className="m-Sponsoring-list" style={{ maxWidth: '996px', minWidth: 'auto', margin: '0 auto' }}>
              {filteredPartner.map((item, index) => (
                <MSponsoringItem key={index} item={item} big={filteredPartner.length === 1 && !filteredPremiumPartner?.length} />
              ))}
            </ul>
          )}
        </div>
      </div>
    </Section>
  )
}

export default MSponsoring
